import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const GeneratedIdDisplay = ({ generatedId, onClose, onAssociate }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard?.writeText(generatedId?.id);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="bg-card rounded-lg border border-border p-6">
      <div className="text-center mb-6">
        <div className="w-20 h-20 bg-success/10 rounded-full flex items-center justify-center mx-auto mb-4">
          <Icon name="CheckCircle" size={40} color="var(--color-success)" />
        </div>
        <h3 className="text-xl font-semibold text-foreground mb-2">ID erfolgreich generiert</h3>
        <p className="text-sm text-muted-foreground">Die eindeutige Kunden-ID wurde erstellt und ist einsatzbereit</p>
      </div>
      {/* Generated ID Display */}
      <div className="bg-gradient-to-br from-primary/5 to-accent/5 rounded-lg p-6 mb-6 border border-primary/20">
        <div className="text-center mb-4">
          <label className="text-xs font-medium text-muted-foreground uppercase tracking-wider">Generierte ID</label>
          <div className="flex items-center justify-center gap-3 mt-3">
            <span className="text-3xl font-bold font-mono text-foreground tracking-wider">{generatedId?.id}</span>
            <button
              onClick={handleCopy}
              className="p-2 hover:bg-muted rounded-md transition-colors"
              title="In Zwischenablage kopieren"
            >
              <Icon name={copied ? 'Check' : 'Copy'} size={20} color={copied ? 'var(--color-success)' : 'var(--color-foreground)'} />
            </button>
          </div>
          {copied && (
            <p className="text-xs text-success mt-2">In Zwischenablage kopiert!</p>
          )}
        </div>

        <div className="grid grid-cols-2 gap-4 pt-4 border-t border-border/50">
          <div className="text-center">
            <Icon name="Calendar" size={16} color="var(--color-muted-foreground)" className="mx-auto mb-1" />
            <p className="text-xs text-muted-foreground">Erstellt am</p>
            <p className="text-sm font-medium text-foreground mt-1">{generatedId?.createdAt}</p>
          </div>
          <div className="text-center">
            <Icon name="User" size={16} color="var(--color-muted-foreground)" className="mx-auto mb-1" />
            <p className="text-xs text-muted-foreground">Erstellt von</p>
            <p className="text-sm font-medium text-foreground mt-1">{generatedId?.createdBy}</p>
          </div>
        </div>
      </div>
      {/* ID Details */}
      <div className="space-y-4 mb-6">
        <div className="grid grid-cols-2 gap-4">
          <div className="bg-muted/50 rounded-lg p-4">
            <div className="flex items-center gap-2 mb-2">
              <Icon name="FileText" size={16} color="var(--color-primary)" />
              <span className="text-xs font-medium text-muted-foreground uppercase tracking-wider">Format</span>
            </div>
            <p className="text-sm font-semibold text-foreground">{generatedId?.format}</p>
          </div>
          <div className="bg-muted/50 rounded-lg p-4">
            <div className="flex items-center gap-2 mb-2">
              <Icon name="Shield" size={16} color="var(--color-success)" />
              <span className="text-xs font-medium text-muted-foreground uppercase tracking-wider">Prüfsumme</span>
            </div>
            <p className="text-sm font-semibold text-foreground">{generatedId?.checksum}</p>
          </div>
        </div>

        <div className="bg-muted/50 rounded-lg p-4">
          <div className="flex items-center gap-2 mb-2">
            <Icon name="Database" size={16} color="var(--color-accent)" />
            <span className="text-xs font-medium text-muted-foreground uppercase tracking-wider">Synchronisationsstatus</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="flex items-center gap-2 px-3 py-1.5 bg-success/10 text-success rounded-md text-xs font-medium">
              <Icon name="CheckCircle" size={14} />
              <span>Mit Hauptsystem synchronisiert</span>
            </div>
          </div>
        </div>

        {generatedId?.notes && (
          <div className="bg-muted/50 rounded-lg p-4">
            <div className="flex items-center gap-2 mb-2">
              <Icon name="FileText" size={16} color="var(--color-muted-foreground)" />
              <span className="text-xs font-medium text-muted-foreground uppercase tracking-wider">Begründung</span>
            </div>
            <p className="text-sm text-foreground">{generatedId?.notes}</p>
          </div>
        )}
      </div>
      {/* Validation Info */}
      <div className="bg-accent/5 border border-accent/20 rounded-lg p-4 mb-6">
        <div className="flex items-start gap-3">
          <Icon name="ShieldCheck" size={20} color="var(--color-accent)" className="flex-shrink-0 mt-0.5" />
          <div>
            <p className="text-sm font-medium text-foreground mb-1">Validierung abgeschlossen</p>
            <ul className="text-xs text-muted-foreground space-y-1">
              <li>✓ Eindeutigkeit bestätigt</li>
              <li>✓ Formatvalidierung erfolgreich</li>
              <li>✓ Prüfsumme verifiziert</li>
              <li>✓ Keine Duplikate gefunden</li>
            </ul>
          </div>
        </div>
      </div>
      {/* Action Buttons */}
      <div className="flex items-center gap-3">
        <button
          onClick={onAssociate}
          className="flex-1 flex items-center justify-center gap-2 px-4 py-3 bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-colors font-medium"
        >
          <Icon name="Link" size={20} />
          <span>Mit Kundenprofil verknüpfen</span>
        </button>
        <button
          onClick={onClose}
          className="px-4 py-3 border border-border rounded-md hover:bg-muted transition-colors text-foreground font-medium"
        >
          Schließen
        </button>
      </div>
    </div>
  );
};

export default GeneratedIdDisplay;